import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ContentWrapper = styled(Box)(({ theme }) => ({
  borderRadius: '24px',
  background: theme.palette.background.paper,
  width: '100%'
}));
